var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-shell",attrs:{"id":"app"}},[_c('div',{staticClass:"ambient-grid",attrs:{"aria-hidden":"true"}}),_c('NavBar'),_c('main',{staticClass:"site-main"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }